import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { useMutation } from '@tanstack/react-query';

import type { PersonDataResponse, PersonDataRequest } from '../model';

export const useUpdatePersonData = () => {
  return useMutation({
    mutationFn: (data: PersonDataRequest) => {
      return makeRequest<ResponseSuccess<PersonDataResponse>>({
        url: `${config.apiHost}/merchant-origination/api/v1/person/update`,
        httpMethod: 'POST',
        credentials: 'include',
        payload: data,
      }).then((response) => response.payload);
    },
  });
};
